import script from "./powerStationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./powerStationItem.vue?vue&type=script&setup=true&lang=js"

import "./powerStationItem.vue?vue&type=style&index=0&id=47749eb8&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47749eb8"]])

export default __exports__